import { forwardRef } from 'react';

import {
  OutlineCircleClockIcon,
  Text,
  type TextProps,
} from '@frontend/legacy-components';

export type PaneSubtitleProps = TextProps;

export const PaneSubtitle = forwardRef<HTMLParagraphElement, PaneSubtitleProps>(
  ({ children, ...props }, ref) => (
    <Text
      ref={ref}
      fontSize="sm"
      lineHeight="sm"
      color="feature.secondary"
      margin={0}
      display="inline-flex"
      alignItems="center"
      {...props}
    >
      <OutlineCircleClockIcon size={2.25} mr={0.5} />
      {children}
    </Text>
  ),
);

PaneSubtitle.displayName = 'PaneSubtitle';
